module.exports = __webpack_public_path__ + "static/fourth_user_image1-ff8e568cb06f304323d22c7de8fb0aeb.jpg";